/* eslint-disable no-restricted-globals, no-restricted-syntax */
import { Permission } from 'common/constants'
import { Asset } from 'common/models'
import { AssetDividingForm } from 'containers/assets'
import { get, isEqual } from 'lodash'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTerms } from 'store/settings/accountingPeriod/actions'
import { selectTermsData } from 'store/settings/accountingPeriod/selectors'
import { getExciseSettingsByDateList } from 'store/settings/excise/selectors'

import { useAssetDiving } from './hooks/use-asset-dividing'

export interface AssetDividingProps {
  asset: Asset
  errors?: any
  causes: any[]
  isShow: boolean
  permissions: Permission
  onHandleReloadCauses?: () => void
  setShowForm: (isShow: boolean) => void
  setRegisterEvent: (registerType: string) => void
  setIsShowConfirmMessage: (value: boolean) => void
}

export const DividingForm = (props: AssetDividingProps) => {
  const dispatch = useDispatch()
  const { valuesForm, handleSubmit, isLoading, errorResponse, ledgerSettings } = useAssetDiving(props)
  const terms = useSelector(selectTermsData, isEqual)
  const exciseSettingsByDateData = useSelector(getExciseSettingsByDateList, isEqual)
  const exciseTaxMethod = get(exciseSettingsByDateData, 'data.tax_method')

  useEffect(() => {
    dispatch(fetchTerms())
  }, [dispatch])

  return (
    <AssetDividingForm
      {...props}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      defaultValues={valuesForm}
      ledgerSettings={ledgerSettings}
      errors={errorResponse}
      terms={terms}
      exciseTaxMethod={exciseTaxMethod}
    />
  )
}
